import { useDispatch, useSelector } from 'react-redux';
import PerformanceCard from '../PerformanceCard';
import ConversionTimeContent from './ConversionTimeContent';
import ConversionTimeEmptyState from './ConversionTimeEmptyState';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceConversionTimeCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ConversionTime() {
  const dispatch = useDispatch();
  const { conversionTime } = useSelector((state) => state.DashboardSlice);
  const { mdn, max, min, loading, hasFetched } = conversionTime;
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const showEmptyState = !mdn && !max && !min;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceConversionTimeCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'conversionTime',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="conversion-time"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'MedianConversionTime')}
      </PerformanceCard.Header>
      {showEmptyState ? (
        <ConversionTimeEmptyState />
      ) : (
        <ConversionTimeContent />
      )}
    </PerformanceCard>
  );
}
